import React, { useEffect } from 'react';
import clsx from 'clsx';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const MethodTypeSelection = (props) => {
  const { entity, functionName, setFunctionName, newSelected, entityName, attributeTypeService, setAttributeTypeService, servicesNames } = props;

  const [functionTargets, setFunctionTargets] = React.useState(['none']);
  const basicFunctions = [ 'create', 'delete', 'getAll', 'get', 'update', 'service', 'getByParams'];

  const selectMethodType = (option) => {
    setFunctionName(option);
  };

  const selectAttributeTypeService = (option) => {
    setAttributeTypeService(option);
  }

  useEffect(() => {

    if(entity === 'none' && newSelected === false){
      setFunctionTargets(['none']);
    }
    else if(entity !== 'none' && newSelected === false){
      const newFunctionTargets = basicFunctions.filter( func => func !== 'none').map(func => func+entity);
      newFunctionTargets.push('none')
      setFunctionTargets(newFunctionTargets);
    }
    else if( entityName !== '' && newSelected === true){
      const newFunctionTargets = basicFunctions.filter( func => func !== 'none').map(func => func+entityName);
      newFunctionTargets.push('none')
      setFunctionTargets(newFunctionTargets);
    }

  }, [entity, entityName, newSelected]);


  return (
    <div className={clsx('spacingTopDiv')} style={{ display: 'flex', flexDirection: 'row' }}>
      <span>
        Method : <span style={{ display: 'inline-block', marginLeft: '6.7vw' }} />
      </span>
      <div className={clsx('flexProps2')}>
        <div>
          <span>
            <DropdownMechanism
              target={functionName}
              targets={functionTargets}
              selectTarget={selectMethodType}
            />
          </span>
          { (functionName === `service${entity}` || functionName === `service${entityName}` ) &&
              <span>
                &nbsp;&nbsp;
                <DropdownMechanism
                  target={attributeTypeService}
                  targets={servicesNames}
                  selectTarget={selectAttributeTypeService}
                />
              </span>
          }
        </div>
        <DisplayError
          styleCondition={functionName === 'none' || (functionTargets.length === 1 && entity === 'none')}
          displayTextCondition={functionTargets.length > 1}
          errorMessage1='Method none'
          errorMessage2='Please link to an entity to display its methods'
        />
        <DisplayError
          styleCondition={(functionName === `service${entity}` || functionName === `service${entityName}` ) && attributeTypeService === 'none'}
          displayTextCondition={(functionName === `service${entity}` || functionName === `service${entityName}`) && attributeTypeService === 'none'}
          errorMessage1='Service none'
          errorMessage2=''
        />
      </div>
    </div>
  );
};

const DisplayError = (props) => {
  
  const { styleCondition, displayTextCondition, errorMessage1, errorMessage2 } = props;
  
  return(
    <span
        className={clsx('MuiFormHelperText-root', 'Mui-error')}
        style={ styleCondition
            ? { display: 'inherit' }
            : { display: 'none' }
        }
      >
        { displayTextCondition
          ? errorMessage1
          : errorMessage2
        }
      </span>
   
  )
}


export default MethodTypeSelection;
